import SbcaasLogo from '@/assets/images/sbcaas.svg';

const SBCIcon = ({ size = 25 }) => (
    <img src={SbcaasLogo} alt="SBCaaS" style={{ height: size, width: size }} />
);

export default SBCIcon;
